var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from 'react';
import { Check } from '@olxbr/ds-icons';
import * as S from './Options.styles';
export const Options = _a => {
  var {
      filteredItems,
      selectedItems,
      handleCheckboxChange,
      showDropdownList,
      isOpen,
      sizeMaxOverflow
    } = _a,
    props = __rest(_a, ["filteredItems", "selectedItems", "handleCheckboxChange", "showDropdownList", "isOpen", "sizeMaxOverflow"]);
  if (!showDropdownList || !filteredItems) return null;
  return React.createElement(S.OptionsWrapper, Object.assign({
    sizeMaxOverflow: sizeMaxOverflow,
    role: "listbox"
  }, props), filteredItems.length === 0 && React.createElement(S.Empty, null, "Nenhum item encontrado"), filteredItems === null || filteredItems === void 0 ? void 0 : filteredItems.map((item, index) => {
    var _a;
    const itemValue = ((_a = item.value) === null || _a === void 0 ? void 0 : _a.toString()) || '';
    const isSelected = selectedItems.includes(itemValue);
    return React.createElement(S.CheckboxButton, {
      "aria-posinset": index + 1,
      "aria-setsize": filteredItems.length,
      key: item.id,
      role: "option",
      "aria-selected": isSelected,
      onClick: () => handleCheckboxChange(itemValue),
      disabled: item.disabled,
      className: "ds-multiselect-option",
      tabIndex: isOpen ? 0 : -1
    }, React.createElement(S.CheckIconWrapper, {
      className: isSelected ? 'visible' : 'hidden'
    }, React.createElement(Check, null)), item.label);
  }));
};